import angular from 'angular';
import template from './template.html';
import './style.scss';

export class ExperienceSection {}

export const ExperienceSectionConfiguration = {
    template,
    controller: ExperienceSection,
    bindings: {
        employmentHistory: '<',
        canEdit: '<',
    },
    controllerAs: 'experienceSectionCtrl'
};

angular
    .module('TALENYA-FE')
    .component('candidateExperienceSection', ExperienceSectionConfiguration);
